import {deviceStore} from "../redux/device/deviceStore";

export class NormalizedMidiInput {
  private readonly midiInput: WebMidi.MIDIInput;
  private readonly uniqueName: string;
  private readonly effectiveId: string;


  constructor(midiInput: WebMidi.MIDIInput, uniqueName: string) {
    this.midiInput = midiInput;
    this.uniqueName = uniqueName;

    // On all OSs, ids are unique. However, on Android, the id is not consistent from one keyboard plug-in to another.
    // For Android, we use the uniqueName as the effectiveId.
    // On Android names are not unique. So we make them unique. We're also assuming here that when you plug in a device,
    // the inputs on the device are registered in the same order.
    const isAndroid = deviceStore.getDeviceOsIsAndroid();
    this.effectiveId = isAndroid ? this.uniqueName : this.midiInput.id.toString();
  }

  public getId(): string {
    return this.effectiveId;
  }

  public getName(): string {
    return this.uniqueName;
  }

  public getMidiInput(): WebMidi.MIDIInput {
    return this.midiInput;
  }

  public toString(): string {
    return `{ effectiveId: ${this.effectiveId}, id: ${this.midiInput.id.toString()}, name: ${this.uniqueName} }`;
  }

}